import React from "react";
import Icon from "../../../../core-components/IconsSelector";
import * as S from "./CabInfoList.styles";

interface IDetails {
  data: string;
  icon?: string;
  tag?: string;
}

interface ICabInfo {
  details: Array<IDetails>;
}

const CabInfoListUI: React.FC<ICabInfo> = ({ details = [] }) => {
  return (
    <S.CabInfo>
      {details.map(({ data = "", tag = "", icon = "" }, index) => (
        <li key={`CabInfo${index}`}>
          <S.IconWrap borderWidth={icon ? "0" : ""}>
            {icon ? <img alt="amentity" src={icon} /> : <Icon name="Iconback" />}
          </S.IconWrap>
          <span>{data}</span>
          {tag ? <span className="newTag">NEW</span> : null}
        </li>
      ))}
    </S.CabInfo>
  );
};

export default React.memo(CabInfoListUI);
